import { render, staticRenderFns } from "./CourseTransferMoneyList.vue?vue&type=template&id=679410cd&scoped=true"
import script from "./CourseTransferMoneyList.vue?vue&type=script&lang=js"
export * from "./CourseTransferMoneyList.vue?vue&type=script&lang=js"
import style0 from "./CourseTransferMoneyList.vue?vue&type=style&index=0&id=679410cd&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679410cd",
  null
  
)

export default component.exports